/**
 * @author vishwadeep.kapoor
 * @Date: 2018-12-18 10:55:03
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2020-12-04 20:30:25
 */

import React, { PureComponent, Fragment } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { shape, number, string, bool, func } from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import Helmet from 'react-helmet';

import { getHeaderConfigUi, TEXT_SEARCH_PLACEHOLDER, TEXT_SEARCH_TYPES, LINK_ANDROID_APP, MOBILE_BREAKPOINT, getHeaderDefaultSearchValue } from './constants'; // CITIES
import { selectHeaderContainer, selectUserDetails, selectLoggedIn, selectCity, getDefaultError, isLoading, getSearchType } from './selectors';
import { setUserCity, setSearchChange, changeWindowSize } from './actions';
import { userLogout } from '../../containers/Profile/actions';
import { constants, utils, eventTracking } from '../../devUtils';
// import SelectWrapper from '../../components/SelectWrapper';
import Modal from '../../components/Modal';
import LoginPage from '../LoginPage';
import DesktopHeader from './desktopHeader';
import { ClientLandingHeader } from './clientLandingHeader';
import MobileHeader from './mobileHeader';
import Loader from '../../components/Loader';
import Alert from '../../components/Alert';
import { displayLoginFrom } from '../LoginPage/actions';
import { selectShowLoginForm, selectIsLoginSuccess } from '../LoginPage/selectors';
import StyledClientLogin from '../ClientLogin/styledClientLogin';
import { MANIPAL_CONFIG } from '../ClientLogin/constants';
import { HelmetWrapper } from '../../components';
import { selectLyraGiftCard } from '../GiftCardLanding/selectors';
import { storeLyraGiftCard } from '../GiftCardLanding/actions';

const ShowRootAlert = ({ reason, msg_type, alertType }) => {
  if (typeof (reason) === 'string') {
    return (<Alert reason={reason} msg_type={msg_type} alertType={alertType} />);
  }
  return null;
};

class HeaderContainer extends PureComponent {
  constructor(props) {
    super(props);
    const { history: { location: { search = '' } }, isLoginSuccess } = this.props;
    this.state = {
      isShowLogin: props.isShowLoginModal,
      is_EnableSearch: false,
      apiResonse: {},
      searchValue: utils.parseQueryString(search).s || '',
      searchType: '',
    };
    this.getHeaderConfigUi = getHeaderConfigUi(props.location);
    this.userSelectedKey = '';
    this.stateLessKeys = {
      isLoginSuccess,
    };
    this.selectedCity = 0;
    this.handleCityChange = this.handleCityChange.bind(this);
    this.handleRouting = this.handleRouting.bind(this);
    this.onLoginClick = this.onLoginClick.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.selectSearchType = this.selectSearchType.bind(this);
    this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
    this.isEnableSearch = this.isEnableSearch.bind(this);
    this.handleBackButton = this.handleBackButton.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.navigateToProfile = this.navigateToProfile.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.checkLoginStatusAndTriggerTracker = this.checkLoginStatusAndTriggerTracker.bind(this);
    this.triggerEventTracker = this.triggerEventTracker.bind(this);
  }

  /**
   * @event lifeCycle @extends React
   */
  componentWillMount() {
    const { getSelectedCity: { id } } = this.props;
    this.selectedCity = id;
    const { searchValue } = this.state;
    const searchParams = this.props.getSearchParams;
    if (searchParams.type && searchParams.value && searchValue) {
      this.setState({ searchType: searchParams.type });
      this.selectSearchType(searchParams.type);
    } else {
      this.setState({ searchType: null });
      this.selectSearchType();
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this._windowResize.bind(this));
    this._windowResize();
  }

  /**
   * @arg apiResonse will be evaluated before the alert
   * @param {object} nextProps
   */
  componentWillReceiveProps(nextProps) {
    const { isLoginSuccess: _isLoginSuccess } = nextProps;
    if (!utils.isEqual(this.props.getSelectedCity, nextProps.getSelectedCity)) {
      const { getSelectedCity: { id } } = nextProps;
      this.selectedCity = id;
    }
    if (!utils.isEqual(this.props.apiResonse, nextProps.apiResonse)) {
      const { apiResonse } = nextProps;
      this.setState({ apiResonse });
    }
    if (!utils.isEqual(this.props.isShowLoginModal, nextProps.isShowLoginModal)) {
      const { isShowLoginModal } = nextProps;
      this.setState({ isShowLogin: isShowLoginModal });
    }
    this.getHeaderConfigUi = getHeaderConfigUi(nextProps.location, nextProps);
    this.stateLessKeys.isLoginSuccess = _isLoginSuccess;
  }

  onLoginClick() {
    const { isShowLogin } = this.state;
    if (isShowLogin) {
      this.setState({ apiResonse: {} });
    }
    this.props.onChangeLoginModalDisplay(!isShowLogin);
  }

  isEnableSearch() {
    const { is_EnableSearch } = this.state;
    this.setState({ is_EnableSearch: !is_EnableSearch });
  }

  /**
   * @event trigger @func onCityChange for changing the city
   * @event trigger @func onSearchChange making @default searchValue=false
   */
  handleCityChange(value, object) {
    const { searchType } = this.state;
    this.props.onCityChange(object);
    this.props.onSearchChange(searchType, 'false');
    this.setState({ searchValue: '' });
    this.triggerEventTracker('Location', 'City Selection', object.city);
  }

  _windowResize() {
    const isMobileScreen = window.innerWidth <= MOBILE_BREAKPOINT;
    this.props.onChangeWindowSize(isMobileScreen);
  }

  handleKeyPress(event) {
    const { searchType, searchValue } = this.state;
    if (event && event.charCode === 13 && searchValue && searchType) {
      this.handleSearchSubmit();
    }
  }

  handleSearchSubmit() {
    const { history, history: { location: { pathname } } } = this.props;
    const { searchType, searchValue } = this.state;
    if (searchValue && searchType) {
      utils.forceRedirect(history, {
        pathname: constants.LINK_SEARCH_RESULT,
        search: `?s=${searchValue}`,
        state: { prePath: pathname },
      });
      this.putSearchChange();
      this.isEnableSearch();
    }
  }

  triggerEventTracker(category, actionType, label = null) {
    const { history: { location: { pathname } } } = this.props;
    eventTracking.triggerEvent(category, actionType, label && label === 'pageName' ? pathname : label);
  }

  handleLogout() {
    const { history, onStoreLyraGiftCard, userDetails: { client_series = '' } = {} } = this.props;
    this.props.onUserLogout(history, { client_series });
    onStoreLyraGiftCard();
  }

  navigateToProfile() {
    const { history } = this.props;
    utils.forceRedirect(history, { pathname: constants.LINK_MY_PROFILE });
  }

  /**
   * @description search @constructor
   * @param {string} value
   */
  selectSearchType(value) {
    const actionType = (value === 'resturants') ? 'Change Search Type to Restaurants' : 'Change Search Type to Gift Cards';
    this.triggerEventTracker('Search', actionType, 'pageName');
    const { searchType } = this.state;
    this.userSelectedKey = value && value;
    const type = getHeaderDefaultSearchValue(this.props.location, searchType, this.userSelectedKey);
    this.setState({ searchType: type });
  }

  putSearchChange() {
    const { searchType, searchValue } = this.state;
    this.props.onSearchChange(searchType, searchValue);
  }

  handleSearch(event) {
    this.setState({ searchValue: event.target.value });
  }

  handleRouting() {
    const { loggedIn, history, isLoginSuccess } = this.props;
    if (loggedIn && isLoginSuccess) {
      this.triggerEventTracker('My Account', 'Header Tab', 'pageName');
      history.push(constants.LINK_MY_PROFILE);
    } else {
      this.triggerEventTracker('Login', 'Login Click', 'pageName');
      this.onLoginClick();
    }
  }

  handleBackButton() {
    const { history } = this.props;
    history.goBack();
  }

  checkLoginStatusAndTriggerTracker(label) {
    const { loggedIn } = this.props;
    const { isLoginSuccess } = this.stateLessKeys;
    if (loggedIn && isLoginSuccess) {
      this.triggerEventTracker('Login', 'Login Click', label);
    }
  }

  /**
   * @function renderLinkConfig
   * @param {*boolean} showTopHeaderLinks @ignore future dependency
   * @param {*boolean} showTopHeaderCardLinks
   */
  renderLinkConfig(showTopHeaderLinks, showTopHeaderCardLinks) {
    const linkAry = [];
    if (showTopHeaderCardLinks) {
      linkAry.push(<Link to={constants.LINK_REDEEM_ZSC} onClick={() => this.triggerEventTracker('Redeem ZSC', 'Header Tab', 'pageName')}>Redeem Zaggle Propel Card</Link>);
      linkAry.push(<Link to={constants.LINK_MANAGE_ZAGGLE_CARD} onClick={() => this.triggerEventTracker('Manage Network Cards', 'Header Tab', 'pageName')}>Manage Zaggle Cards</Link>);
    }
    if (showTopHeaderLinks) {
      // linkAry.push(<Link to="#">For Corporate</Link>);
      linkAry.push(<Link to={constants.LINK_ABOUTUS} style={{ paddingRight: '0px' }} onClick={() => this.triggerEventTracker('Miscellaneous', 'About Us Tab', 'pageName')}>About Us</Link>);
      linkAry.push(<Link to={constants.LINK_CONTACTUS} onClick={() => this.triggerEventTracker('Miscellaneous', 'Contact Us Tab', 'pageName')}>Contact Us</Link>);
    }
    return linkAry;
  }

  renderManipalsignaHeader() {
    const {
      urlPath,
    } = this.state;
    const {
      userDetails: {
        cart,
        isOnlyMerchandise = false,
      },
      loggedIn,
    } = this.props;
    const {
      slider_images, logo, about_title,
      about_description, secondary_title,
      portal_name, redirect_loginSuccess,
      top_banner, welcome_title,
      welcome_description,
      brand_logo, ...otherProps
    } = MANIPAL_CONFIG;
    return (
      <Fragment>
        <StyledClientLogin {...otherProps}>
          <ClientLandingHeader
            brand_logo={brand_logo}
            logo={logo}
            portal_name={portal_name}
            top_banner={top_banner}
            isOnlyMerchandise={urlPath === constants.LINK_CLIENT_MANIPAL || isOnlyMerchandise}
            isLoggedIn={loggedIn}
            handleShowLogin={this.onLoginClick}
            handleLogout={this.handleLogout}
            pathname={urlPath}
            cart={cart}
          />
        </StyledClientLogin>
      </Fragment>
    );
  }

  render() {
    const {
      location,
      userDetails: {
        cart,
        isOnlyMerchandise,
        name,
        image: {
          thumb_url,
        } = {},
        client_series = '',
        lyra_pg_enabled = false,
      } = {},
      loggedIn,
      isLoadingStatus,
      history,
      lyraGiftCardDetails,
    } = this.props;
    const {
      isShowLogin,
      is_EnableSearch,
      apiResonse,
    } = this.state;
    const {
      showTopHeaderCardLinks,
      primaryHeaderTitle,
      showTopHeaderLinks,
      topHeaderImage,
    } = this.getHeaderConfigUi;
    const {
      isLoginSuccess,
    } = this.stateLessKeys;
    const searchKeys = {
      searchType: this.state.searchType,
      searchValue: this.state.searchValue,
    };
    if (isLoadingStatus) {
      return <Loader />;
    }
    return (
      <div>
        {process.env.NODE_ENV === 'production' ?
          <Fragment>
            <Helmet>
              <script>{`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-M5NVXR');`}
              </script>
            </Helmet>
            <HelmetWrapper location={location} />
          </Fragment> : null}
        {ShowRootAlert(apiResonse)}
        <Modal
          show={isShowLogin}
          header="Login"
          size="login"
          classname="without-header"
          onClose={this.onLoginClick}
        >
          {isShowLogin && <LoginPage isShowLogin={isShowLogin} apiResonse={apiResonse} history={history} />}
        </Modal>
        <MobileHeader
          handleBackButton={this.handleBackButton}
          TEXT_SEARCH_TYPES={TEXT_SEARCH_TYPES}
          TEXT_SEARCH_PLACEHOLDER={TEXT_SEARCH_PLACEHOLDER}
          cart={cart}
          name={name}
          thumb_url={thumb_url}
          getHeaderConfigUi={this.getHeaderConfigUi}
          LINK_ANDROID_APP={LINK_ANDROID_APP}
          stateLessKeys={searchKeys}
          selectSearchType={this.selectSearchType}
          isEnableSearch={this.isEnableSearch}
          handleSearch={this.handleSearch}
          handleLogout={this.handleLogout}
          handleSearchSubmit={this.handleSearchSubmit}
          is_EnableSearch={is_EnableSearch}
          loggedIn={loggedIn}
          LoginClick={this.onLoginClick}
          gotoProfile={this.navigateToProfile}
          isOnlyMerchandise={isOnlyMerchandise}
          isLoginSuccess={isLoginSuccess}
          history={history}
          client_series={client_series}
        />
        <DesktopHeader
          getHeaderConfigUi={this.getHeaderConfigUi}
          cart={cart}
          loggedIn={loggedIn}
          renderLinkConfig={this.renderLinkConfig(showTopHeaderLinks, showTopHeaderCardLinks)}
          handleRouting={this.handleRouting}
          topHeaderImage={topHeaderImage}
          primaryHeaderTitle={primaryHeaderTitle}
          isLoginSuccess={isLoginSuccess}
          handleEventTracker={this.triggerEventTracker}
          isOnlyMerchandise={isOnlyMerchandise}
          handleLogout={this.handleLogout}
          history={history}
          loginClick={this.onLoginClick}
          client_series={client_series}
          lyraGiftCardDetails={lyraGiftCardDetails}
          lyraPgEnabled={lyra_pg_enabled}
          // handleKeyPress={this.handleKeyPress}
          // handleSearchSubmit={this.handleSearchSubmit}
          // handleSearch={this.handleSearch}
          // TEXT_SEARCH_TYPES={TEXT_SEARCH_TYPES}
          // selectSearchType={this.selectSearchType}
          // TEXT_SEARCH_PLACEHOLDER={TEXT_SEARCH_PLACEHOLDER}
          // stateLessKeys={searchKeys}
        />
      </div>
    );
  }
}

ShowRootAlert.propTypes = {
  reason: string.isRequired,
  msg_type: string.isRequired,
  alertType: string.isRequired,
};

HeaderContainer.defaultProps = {
  loggedIn: false,
  lyraGiftCardDetails: {},
};

HeaderContainer.propTypes = {
  loggedIn: bool,
  isLoadingStatus: bool.isRequired,
  isShowLoginModal: bool.isRequired,
  isLoginSuccess: bool.isRequired,
  getSearchParams: shape({}).isRequired,
  history: shape({}).isRequired,
  getSelectedCity: shape({}).isRequired,
  apiResonse: shape({}).isRequired,
  userDetails: shape({
    cart: shape({
      items_count: number,
    }),
    isOnlyMerchandise: bool,
  }).isRequired,
  location: shape({
    pathname: string,
  }).isRequired,
  lyraGiftCardDetails: shape({}),
  onCityChange: func.isRequired,
  onSearchChange: func.isRequired,
  onUserLogout: func.isRequired,
  onChangeLoginModalDisplay: func.isRequired,
  onChangeWindowSize: func.isRequired,
  onStoreLyraGiftCard: func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  onCityChange: (payload) => dispatch(setUserCity(payload)),
  onSearchChange: (type, value) => dispatch(setSearchChange(type, value)),
  onUserLogout: (history, otherParams) => dispatch(userLogout(history, otherParams)),
  onChangeLoginModalDisplay: (payload) => dispatch(displayLoginFrom(payload)),
  onChangeWindowSize: (payload) => dispatch(changeWindowSize(payload)),
  onStoreLyraGiftCard: (payload) => dispatch(storeLyraGiftCard(payload)),
});

const mapStateToProps = createStructuredSelector({
  HeaderContainer: selectHeaderContainer(),
  userDetails: selectUserDetails(),
  loggedIn: selectLoggedIn(),
  getSelectedCity: selectCity(),
  apiResonse: getDefaultError(),
  isLoadingStatus: isLoading(),
  isShowLoginModal: selectShowLoginForm(),
  isLoginSuccess: selectIsLoginSuccess(),
  getSearchParams: getSearchType(),
  lyraGiftCardDetails: selectLyraGiftCard('lyraGiftCardDetails'),
});

const component = connect(mapStateToProps, mapDispatchToProps)(withRouter(HeaderContainer));
export { ShowRootAlert, HeaderContainer, mapStateToProps, mapDispatchToProps };
export default component;



// WEBPACK FOOTER //
// client/containers/HeaderContainer/index.js